<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <form-base
          :submit-status="submitStatus"
          action="Update"
          :errors="errors"
          :loading="loading"
          v-on:handleSubmit="handleSubmit"
        >
          <template v-slot:fields>
            <form-group label="Status" :required="true">
              <b-form-select
                @blur="$v.customer.status.$touch"
                :class="{ 'is-invalid': $v.customer.status.$error }"
                v-model="customer.status"
                :options="statuses"
              />
              <div class="invalid-feedback" v-if="!$v.customer.status.required">
                Please select status
              </div>
            </form-group>

            <form-group label="Branch" :required="true">
              <b-form-select
                @blur="$v.customer.branch_id.$touch"
                :class="{ 'is-invalid': $v.customer.branch_id.$error }"
                v-model="customer.branch_id"
                :options="branches"
                text-field="name"
                value-field="id"
              />
              <div
                class="invalid-feedback"
                v-if="!$v.customer.branch_id.required"
              >
                Please select branch
              </div>
            </form-group>

            <form-group label="Rapid Code" :required="true">
              <input
                @blur="$v.customer.rapid_code.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.customer.rapid_code.$error }"
                v-model="customer.rapid_code"
                v-uppercase
              />
              <div
                class="invalid-feedback"
                v-if="!$v.customer.rapid_code.required"
              >
                Please enter rapid code
              </div>
            </form-group>

             <form-group label="Rep Code" :required="true">
              <input
                @blur="$v.customer.rep_code.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.customer.rep_code.$error }"
                v-model="customer.rep_code"
                v-uppercase
              />
              <div
                class="invalid-feedback"
                v-if="!$v.customer.rep_code.required"
              >
                Please enter rep code
              </div>
            </form-group>

            <form-group label="Name" :required="true">
              <input
                @blur="$v.customer.name.$touch"
                class="form-control"
                :class="{ 'is-invalid': $v.customer.name.$error }"
                v-model="customer.name"
              />
              <div class="invalid-feedback" v-if="!$v.customer.name.required">
                Please enter name
              </div>
            </form-group>

            <form-group label="Contact Person">
              <input class="form-control" v-model="customer.contact_person" />
            </form-group>

            <form-group label="Trading As">
              <input class="form-control" v-model="customer.trading_as" />
            </form-group>

            <form-group label="Physical Address">
              <textarea-autosize
                class="form-control"
                v-model="customer.physical_address"
              />
            </form-group>

            <form-group label="Area">
              <input class="form-control" v-model="customer.area" />
            </form-group>

            <form-group label="Phone">
              <input class="form-control" v-model="customer.phone_1" />
            </form-group>

            <form-group label="Phone">
              <input class="form-control" v-model="customer.phone_2" />
            </form-group>

            <form-group label="Phone">
              <input class="form-control" v-model="customer.phone_3" />
            </form-group>

            <form-group label="Email">
              <input
                type="email"
                class="form-control"
                v-model="customer.email_address"
              />
            </form-group>

            <form-group label="Credit Limit">
              <input
                type="number"
                class="form-control"
                v-model="customer.credit_limit"
              />
            </form-group>

            <form-group label="Max Credit Limit">
              <input
                type="number"
                class="form-control"
                v-model="customer.max_credit_limit"
              />
            </form-group>

            <form-group label="Current Balance">
              <input
                type="number"
                class="form-control"
                v-model="customer.current_balance"
              />
            </form-group>

            <form-group label="Aging Current">
              <input
                type="number"
                class="form-control"
                v-model="customer.aging_current"
              />
            </form-group>

            <form-group label="Aging 30">
              <input
                type="number"
                class="form-control"
                v-model="customer.aging_30"
              />
            </form-group>

            <form-group label="Aging 60">
              <input
                type="number"
                class="form-control"
                v-model="customer.aging_60"
              />
            </form-group>

            <form-group label="Aging 90">
              <input
                type="number"
                class="form-control"
                v-model="customer.aging_90"
              />
            </form-group>

            <form-group label="Aging 90+">
              <input
                type="number"
                class="form-control"
                v-model="customer.aging_90_plus"
              />
            </form-group>

            <form-group label="Account Type">
              <input class="form-control" v-model="customer.account_type" />
            </form-group>

            <form-group label="Notes">
              <textarea-autosize
                class="form-control"
                v-model="customer.notes"
              />
            </form-group>
          </template>
        </form-base>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import customerRepo from "@/api/repos/customerRepo";
import { required } from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";

export default {
  components: {
    formBase,
    formGroup,
  },

  computed: {
    imageVstate: function () {
      return null;
    },
  },

  validations: {
    customer: {
      rapid_code: {
        required,
      },
      name: {
        required,
      },
      branch_id: {
        required,
      },
      rep_code: {
        required,
      },
      status: {
        required,
      },
    },
  },

  mounted() {
    this.getData();
    this.getCustomer();
  },

  props: ["id"],

  data() {
    return {
      customer: {},
      branches: [],
      loading: false,
      errors: null,
      submitStatus: null,
      statuses: ["Active", "Black Listed", "Obsolete"],
    };
  },

  methods: {
    async getData() {
      try {
        let { data } = await customerRepo.createGetData();
        this.branches = data.branches;
      } catch (error) {
        console.log(error);
      }
    },

    async getCustomer() {
      try {
        this.loading = true;
        let { data } = await customerRepo.get(this.id);
        this.customer = data.customer;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid || this.imageUploading) {
        if (this.imageUploading) alert("images uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {
        try {
          await customerRepo.update(this.id, this.customer);
          this.$emit("customerUpdated");
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            console.log(this.errors);
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
